<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showStoreHourSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'840px'}">
    <ng-template pTemplate="header">
            <div class="sidebar-header-title">Hours</div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading" style="margin: 0 -14px;">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 185px)'}"
                       [styleClass]="'app-scrollpanel'">
            <partner-mart-locations-hours [operationHours]="operationHours"
                                          [specialHours]="specialHours"></partner-mart-locations-hours>
        </p-scrollPanel>
    </div>

    <div class="flex justify-content-end mrg-10-0px p-4">
        <button class="bluedark-btn" pButton label="Save" (click)="updateStore()"></button>
    </div>

</p-sidebar>